module.exports = __webpack_public_path__ + "static/img/nft_banner.11d81450.jpg";